import React, { useState, useEffect } from 'react';

import { DropdownContext } from './DropdownContext';

// Dropdown Provider component to manage the state and click handling
function DropdownProvider({ children }) {
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleOutsideClick = event => {
    if (openDropdown && (!openDropdown.contains(event.target) || event.target?.classList?.contains('multiselect-dropdown-save-button'))) {
      // console.log('setting null', openDropdown, event.target);
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openDropdown]);

  return (
    <DropdownContext.Provider value={{ openDropdown, setOpenDropdown }}>
      {children}
    </DropdownContext.Provider>
  );
}

export default DropdownProvider;
